import SendAmount from './SendAmount';

export default SendAmount;
